// Pull-to-refresh indicator component for mobile
import { Loader2, ArrowDown } from 'lucide-react'
import { cn } from '@/lib/utils'

interface PullToRefreshIndicatorProps {
  pullDistance: number
  isRefreshing: boolean
  threshold?: number
}

export function PullToRefreshIndicator({
  pullDistance,
  isRefreshing,
  threshold = 80,
}: PullToRefreshIndicatorProps) {
  if (pullDistance === 0 && !isRefreshing) return null
  
  const progress = Math.min(pullDistance / threshold, 1)
  const shouldTrigger = pullDistance >= threshold
  
  return (
    <div 
      className="flex items-center justify-center py-2 transition-all duration-200 md:hidden"
      style={{ 
        height: pullDistance,
        opacity: Math.min(progress * 2, 1)
      }}
    >
      <div className={cn(
        "flex items-center gap-2 text-sm text-muted-foreground",
        shouldTrigger && "text-primary"
      )}>
        {isRefreshing ? (
          <>
            <Loader2 className="h-4 w-4 animate-spin" />
            <span>Refreshing...</span>
          </>
        ) : (
          <>
            <ArrowDown 
              className={cn(
                "h-4 w-4 transition-transform duration-200",
                shouldTrigger && "rotate-180"
              )}
            />
            <span>
              {shouldTrigger ? "Release to refresh" : "Pull to refresh"}
            </span>
          </>
        )}
      </div>
    </div>
  )
}
